/** External dependencies */
// import { Handlebars } from 'handlebars/runtime';

/** Internal dependencies */
import { showItem } from './utilities';

export function updateItems(parent, result) {
    const items = result.data;
    const termsString = result.terms;
    const itemsContainer = parent.querySelector('[data-items]');
    const tmpl = parent.querySelector('.hbstmpl');
    const source = tmpl.innerHTML;
    const template = Handlebars.compile(source);

    if (termsString) {
        const terms = JSON.parse(termsString);
        Object.entries(terms).forEach(([taxonomy, termIds]) => {
            // get all filters for this taxonomy
            const filters = parent.querySelectorAll(`input[name="${taxonomy}"]`);

            if (filters) {
                filters.forEach((filter) => {
                    // if this filters value is not in termIds, disable it
                    if (termIds.indexOf(parseInt(filter.value)) === -1) {
                        filter.disabled = true;
                    } else {
                        // otherwise enable the filter: this is relevant after filters had been deactivated
                        filter.disabled = false;
                    }
                });
            }
        });
    }

    // This function is only called if `result` is an array
    items.forEach((item) => {
        const html = template(item);

        if (parent.getAttribute('data-rest-masonry')) {
            const $elems = jQuery(html);
            jQuery('.grid').append($elems).masonry('appended', $elems);
        } else {
            itemsContainer.insertAdjacentHTML('beforeend', html);
        }

        showItem(item.id);
    });
}
